export interface IYearInfoDTO {
  branch_count: number;
  teams: IYearInfoTeamCountDTO[];
  registration_fees: number;
  incomplete_registrations: number;
}
export interface IYearInfoTeamCountDTO {
  name: string;
  count: number;
  id: string;
}

export class YearInfoDTO implements IYearInfoDTO {
  branch_count: number;
  teams: IYearInfoTeamCountDTO[];
  registration_fees: number;
  incomplete_registrations: number;

  constructor() {
    this.branch_count = 0;
    this.teams = [];
    this.registration_fees = 0.0;
    this.incomplete_registrations = 0;
  }
}
